import { render } from "./RoleMenuItem.vue?vue&type=template&id=7c81ebc5&scoped=true"
import script from "./RoleMenuItem.vue?vue&type=script&lang=js"
export * from "./RoleMenuItem.vue?vue&type=script&lang=js"

import "./RoleMenuItem.vue?vue&type=style&index=0&id=7c81ebc5&scoped=true&lang=css"

import exportComponent from "D:\\newProjectGit\\HbzsbAdminClient\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c81ebc5"]])

export default __exports__